const env = process.env.REACT_APP_ENV;

export const appConfig = {
  api: {
    networkInterface: {
      development: "https://dev.lease-revamp.api.sparta.aero/lm",
      staging: "https://qa.lease-revamp.api.sparta.aero/lm",
      uat: "https://uat-lms.api.sparta.aero/lm",
      production: "https://api-lms.sparta.aero/lm",
    }[env],
    notification: {
      development: "https://dev.beta.sparta.aero:8222",
      staging: "https://qa.beta.sparta.aero:8223",
      uat: "https://uat-api.sparta.aero/",
      production: "https://api.sparta.aero/",
    }[env],
    commonApi: {
      development: "https://dev.lease-revamp.api.sparta.aero/console",
      staging: "https://qa.beta.sparta.aero:8223/console",
      uat: "https://uat-lms.api.sparta.aero/lm",
      production: "https://api-lms.sparta.aero/lm",
    }[env],
    s3ImageUrl: {
      development: "https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/",
      staging: "https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/",
      uat: "https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/",
      production: "https://sparta-aims.ams3.cdn.digitaloceanspaces.com/others/assets/img/",
    }[env],
    appUrl: {
      development: "http://local.sparta.aero:3000/",
      staging: "https://qa.analytics.sparta.aero/",
      uat: "https://uat.analytics.sparta.aero/",
      production: "https://analytics.sparta.aero/",
    }[env],
  },
  mixpanel: {
    key: {
      production: "ab606abea19b798536dbc88360491951",
      staging: "7d24f7c9fd11f07a810f16f78fddb450",
      uat: "7d24f7c9fd11f07a810f16f78fddb450",
      development: "7d24f7c9fd11f07a810f16f78fddb450",
    }[env],
  },
  env: {
    key: {
      production: "api",
      staging: "qa",
      uat: "uat",
      development: "dev",
    }[env],
  },
  domain: {
    analytics: {
      development: "http://dev.analytics.sparta.aero/",
      staging: "https://qa.analytics.sparta.aero/",
      uat: "https://uat-analytics.sparta.aero/",
      production: "https://analytics.sparta.aero/",
    }[env],
    subDomian: {
      development: "https://dev.console.sparta.aero/",
      staging: "https://qa.console.sparta.aero/",
      uat: "https://uat-console.sparta.aero/",
      production: "https://sparta.aero/",
    }[env],
    lease: {
      development: "https://dev.lease.sparta.aero/",
      staging: "https://qa.lease.sparta.aero/",
      uat: "https://uat-lease.sparta.aero/",
      production: "https://lease.sparta.aero/",
    }[env],
    maintenance: {
      development: "https://dev.maintenance.sparta.aero/",
      staging: "https://qa.maintenance.sparta.aero/",
      uat: "https://uat-maintenance.sparta.aero/",
      production: "https://maintenance.sparta.aero/",
    }[env],
    projects: {
      development: "https://dev.projects.sparta.aero/",
      staging: "https://qa.projects.sparta.aero/",
      uat: "https://uat-projects.sparta.aero/",
      production: "https://projects.sparta.aero/",
    }[env],
    valuation: {
      development: "https://dev.fin-s.sparta.aero/",
      staging: "https://qa.fin-s.sparta.aero/",
      uat: "https://uat-fin-s.sparta.aero/",
      production: "https://fin-s.sparta.aero/",
    }[env],
    mrCalculator: {
      development: "https://dev.commverge.sparta.aero/",
      staging: "https://qa.commverge.sparta.aero/",
      uat: "https://uat-commverge.sparta.aero/",
      production: "https://commverge.sparta.aero/",
    }[env],
    records: {
      development: "https://dev.records.sparta.aero/",
      staging: "https://qa.records.sparta.aero/",
      uat: "https://uat-records.sparta.aero/",
      production: "https://records.sparta.aero/",
    }[env],
    camo: {
      development: "https://dev.camo.sparta.aero/",
      staging: "https://qa.camo.sparta.aero/",
      uat: "https://uat-camo.sparta.aero/",
      production: "https://camo.sparta.aero/",
    }[env],
  },
  lessorIds: [484],
};

export default appConfig;
